/**
 * @generated SignedSource<<f750a8c4f3fce05ba230c1784bab91b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useEnablePushNotifications_notificationSubscriptions$data = {
  readonly id: string;
  readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
  readonly " $fragmentType": "useEnablePushNotifications_notificationSubscriptions";
};
export type useEnablePushNotifications_notificationSubscriptions$key = {
  readonly " $data"?: useEnablePushNotifications_notificationSubscriptions$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEnablePushNotifications_notificationSubscriptions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEnablePushNotifications_notificationSubscriptions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyInviteContactChannels",
      "storageKey": null
    }
  ],
  "type": "NotificationSubscriptions",
  "abstractKey": null
};

(node as any).hash = "9f9f230645290c55a5a5524fa69c20d5";

export default node;
